import PropTypes from 'prop-types';
import {
    BtnBold,
    BtnBulletList,
    BtnClearFormatting,
    BtnItalic,
    BtnLink,
    BtnNumberedList,
    BtnRedo,
    BtnStrikeThrough,
    BtnStyles,
    BtnUnderline,
    BtnUndo,
    Editor,
    EditorProvider,
    Separator,
    Toolbar,
} from 'react-simple-wysiwyg';
import {Box} from '@mui/material';

const RichEditor = ({index, value, onChange, isFormLive}) => {

    return (
        <EditorProvider>
            <Toolbar>
                <BtnUndo/>
                <BtnRedo/>
                <Separator/>
                <BtnBold/>
                <BtnItalic/>
                <BtnUnderline/>
                <BtnStrikeThrough/>
                <Separator/>
                <BtnNumberedList/>
                <BtnBulletList/>
                <Separator/>
                <BtnLink/>
                <BtnClearFormatting/>
                <Separator/>
                <BtnStyles/>
            </Toolbar>
            <Box sx={{cursor: 'text'}}>
                <Editor disabled={isFormLive} value={value}
                        onChange={e => onChange({index, description: e.target.value})}/>
            </Box>
        </EditorProvider>
    );
};

RichEditor.propTypes = {
    id: PropTypes.string,
    value: PropTypes.string,
    index: PropTypes.number,
    onChange: PropTypes.func,
    isEditMode: PropTypes.bool,
    isFormLive: PropTypes.bool,
    readOnly: PropTypes.bool
};

export default RichEditor;